var E = Object.defineProperty;
var F = (p, e, c) => e in p ? E(p, e, { enumerable: !0, configurable: !0, writable: !0, value: c }) : p[e] = c;
var y = (p, e, c) => F(p, typeof e != "symbol" ? e + "" : e, c);
import { createI18n as M } from "vue-i18n";
import { g as v } from "../_commonjsHelpers-DjF3Plf2.js";
import { a as U } from "../js.cookie-OLEfuq_g.js";
import { env as j } from "./envManager.js";
var w = { exports: {} };
(function(p) {
  const e = Object.getPrototypeOf({});
  function c() {
    return function(u) {
      return typeof u == "object" && u !== null && !(u instanceof RegExp) && !(u instanceof Date);
    };
  }
  function o(s) {
    function u(t) {
      return t !== "constructor" && t !== "prototype" && t !== "__proto__";
    }
    function L(t) {
      let r = 0;
      const a = t.length, n = new Array(a);
      for (r; r < a; ++r)
        n[r] = g(t[r]);
      return n;
    }
    function i(t) {
      const r = {};
      if (O && Object.getPrototypeOf(t) !== e)
        return O(t);
      const a = b(t);
      let n, l, f;
      for (n = 0, l = a.length; n < l; ++n)
        u(f = a[n]) && (r[f] = g(t[f]));
      return r;
    }
    function h(t, r) {
      const a = t.length, n = r.length;
      let l = 0;
      const f = new Array(a + n);
      for (l; l < a; ++l)
        f[l] = g(t[l]);
      for (l = 0; l < n; ++l)
        f[l + a] = g(r[l]);
      return f;
    }
    const P = Object.prototype.propertyIsEnumerable;
    function x(t) {
      const r = Object.keys(t), a = Object.getOwnPropertySymbols(t);
      for (let n = 0, l = a.length; n < l; ++n)
        P.call(t, a[n]) && r.push(a[n]);
      return r;
    }
    const b = s != null && s.symbols ? x : Object.keys, O = typeof (s == null ? void 0 : s.cloneProtoObject) == "function" ? s.cloneProtoObject : void 0, A = typeof (s == null ? void 0 : s.isMergeableObject) == "function" ? s.isMergeableObject : c();
    function R(t) {
      return typeof t != "object" || t === null;
    }
    const I = s && typeof s.mergeArray == "function" ? s.mergeArray({ clone: g, deepmerge: m, getKeys: b, isMergeableObject: A }) : h;
    function g(t) {
      return A(t) ? Array.isArray(t) ? L(t) : i(t) : t;
    }
    function k(t, r) {
      const a = {}, n = b(t), l = b(r);
      let f, S, d;
      for (f = 0, S = n.length; f < S; ++f)
        u(d = n[f]) && l.indexOf(d) === -1 && (a[d] = g(t[d]));
      for (f = 0, S = l.length; f < S; ++f)
        u(d = l[f]) && (d in t ? n.indexOf(d) !== -1 && (O && A(r[d]) && Object.getPrototypeOf(r[d]) !== e ? a[d] = O(r[d]) : a[d] = m(t[d], r[d])) : a[d] = g(r[d]));
      return a;
    }
    function m(t, r) {
      const a = Array.isArray(r), n = Array.isArray(t);
      return R(r) ? r : A(t) ? a && n ? I(t, r) : a !== n ? g(r) : k(t, r) : g(r);
    }
    function C() {
      switch (arguments.length) {
        case 0:
          return {};
        case 1:
          return g(arguments[0]);
        case 2:
          return m(arguments[0], arguments[1]);
      }
      let t;
      for (let r = 0, a = arguments.length; r < a; ++r)
        t = m(t, arguments[r]);
      return t;
    }
    return s != null && s.all ? C : m;
  }
  p.exports = o, p.exports.default = o, p.exports.deepmerge = o, Object.defineProperty(p.exports, "isMergeableObject", {
    get: c
  });
})(w);
var _ = w.exports;
const K = /* @__PURE__ */ v(_);
class $ {
  constructor() {
    y(this, "defaultLocale");
    y(this, "supportedLocales");
    y(this, "i18n");
    y(this, "localeLoaders");
    y(this, "configured");
    y(this, "state");
    y(this, "setReady");
    y(this, "readyPromise");
    this.configured = !1, this.defaultLocale = "en", this.supportedLocales = ["en"], this.localeLoaders = [], this.i18n = M({
      locale: "xx",
      //Fake local, use fetchAndSetLocaleMessages to init the locale
      legacy: !1,
      messages: {}
    }), this.state = "pending", this.readyPromise = new Promise((e) => {
      this.setReady = () => {
        this.state = "ready", e(!0);
      };
    });
  }
  /**
   * Configure the instance to handle common i18n setup
   * @param localeLoader Function An async function that returns the message for a given locale
   * @param options.defaultLocale string Locale to fallback to
   * @param options.supportedLocales Array<string> Array of supported locales
   */
  configure(e, c) {
    var o;
    return this.localeLoaders.push(e), this.defaultLocale = (c == null ? void 0 : c.defaultLocale) ?? "en", this.supportedLocales = ((o = c == null ? void 0 : c.supportedLocales) == null ? void 0 : o.map((s) => s.toLowerCase())) ?? ["en"], this.isSupportedLocale(this.defaultLocale) || (console.error(
      `I18nService constructor - Default locale ${this.defaultLocale} must be a supported locale`
    ), this.defaultLocale = "en"), this.configured = !0, this;
  }
  /**
   * Add a locale loader to the list of loaders and refetch the messages
   * @param localeLoader Function An async function that returns the message for a given locale
   */
  addLocaleLoader(e) {
    if (this.localeLoaders.includes(e)) {
      console.warn("I18nService addLocaleLoader - Loader already registered");
      return;
    }
    return this.localeLoaders.push(e), this.fetchAndSetLocaleMessages(this.getCurrentLocale(), { force: !0 });
  }
  /**
   * Get current locale from vue-i18n
   */
  getCurrentLocale() {
    return this.i18n.global.locale.value;
  }
  /**
   * Whether the locale is supported
   * @param locale string Locale to check
   * @return boolean true if supported
   */
  isSupportedLocale(e) {
    return this.supportedLocales.includes(e == null ? void 0 : e.toLowerCase());
  }
  /**
   * Compute a supported locale, fallback to default
   * @param locale string
   * @return string a supported locale
   */
  checkSupportedLocales(e) {
    return this.isSupportedLocale(e) ? e : this.defaultLocale;
  }
  /**
   * Preprocess the locale name to Accor standard
   * @param locale string A raw locale which may need to be transformed
   * @return string A transformed locale
   */
  localeFilter(e) {
    return e == "br" ? "pt-br" : e;
  }
  isLegacyRoute(e) {
    return e.path.match(/index\.([\w-]+)\.shtml/);
  }
  /**
   * Get locale and path from old index.locale.shtml#/path URL
   * @param route string Route of the SPA
   * @return object An object with the `locale` and `path` from the legacy SPA routing
   */
  parseLegacyRoute(e) {
    if (!this.isLegacyRoute(e))
      throw new Error(`I18nService parseLegacyRoute - Unsupported route: ${e}`);
    const c = e.hash.slice(1), [, o] = e.path.split(".");
    if (!o || !c)
      throw new Error(`I18nService parseLegacyRoute - Unsupported route: ${e}`);
    const s = this.checkSupportedLocales(o), [, u] = document.location.hash.split("?"), L = u ? Object.fromEntries(
      u.split("&").map((i) => {
        const h = i.split("=");
        try {
          h[1] = decodeURIComponent(h[1]);
        } catch {
          console.warn("i18nService - Fail to decode URI component", h);
        }
        return h;
      })
    ) : {};
    return {
      locale: s,
      route: { path: `/${s}${c}`, query: { ...L, ...e.query } }
    };
  }
  /**
   * Use legacy mechanism to get the locale outside of the route
   * @param route string Route of the SPA
   * @return string User's locale based on cookie or default locale
   */
  fallbackGetUserLocale() {
    return this.checkSupportedLocales(U.get("userLang"));
  }
  /**
   * Based on a route, get the locale set by the user from different source
   * @param to RouteNormalized Route object from vue-router in a guard
   * @return object Has final `locale` and a `path` for redirection if needed
   */
  getLocaleFromRoute(e, c) {
    var u, L, i;
    const o = ((u = e == null ? void 0 : e.params) == null ? void 0 : u.locale) ?? c.params.locale ?? ((L = e.redirectedFrom) == null ? void 0 : L.params.locale);
    if (!this.isLegacyRoute(e) && !o)
      throw new Error("I18nService getLocaleFromRoute - no locale params in routes");
    if (this.isSupportedLocale(o)) {
      const h = { locale: o };
      return (i = e == null ? void 0 : e.params) != null && i.locale || (h.route = { ...e }, h.route.params.locale = o), h;
    }
    try {
      return this.parseLegacyRoute(e);
    } catch {
      console.warn(
        `I18nService getUserLocale - Could not get locale from route: ${e.fullPath}. Fallback to cookie userLang or defaultLocale`
      );
    }
    return {
      locale: this.fallbackGetUserLocale(),
      route: { ...e, params: { locale: this.fallbackGetUserLocale() } }
    };
  }
  /**
   * A function to put in the router which sets the locale of vue-i18n and return a path if a redirection is needed
   * @return Promise<string|boolean> Return path to redirect or true if locale in path is correct
   */
  async routeHandler(e, c) {
    const o = this.getLocaleFromRoute(e, c);
    return await this.fetchAndSetLocaleMessages(o.locale), o.route ? o.route : !0;
  }
  /**
   * Get messages using locale loader, and set the locale and appropriate HTML attributes `lang` and `dir` depenping on the locale
   * @param locale string Locale to get and set
   * @return Promise<void> Resolve when done
   */
  async fetchAndSetLocaleMessages(e, c = { force: !1 }) {
    if (e === "xx" || this.getCurrentLocale() === e && !c.force)
      return;
    const o = this.checkSupportedLocales(this.localeFilter(e)), s = await Promise.all(this.localeLoaders.map((i) => i(o))), u = K(), L = s.reduce((i, h) => u(i, h), {});
    if (this.i18n.global.locale.value = e, this.i18n.global.setLocaleMessage(e, L), this.setReady && this.state === "pending" && this.setReady(), typeof document < "u") {
      const i = document == null ? void 0 : document.querySelector("html");
      i == null || i.setAttribute("lang", o), o === "ar" && (i == null || i.setAttribute("dir", "rtl"));
    }
  }
  enableFilterAllAccorComByEnv() {
    this.i18n.global.setPostTranslationHandler((e) => typeof e != "string" || j.isProd() ? e : j.filterAllAccorComByEnv(e));
  }
}
const N = new $();
export {
  $ as I18nServiceClass,
  N as i18nService
};
//# sourceMappingURL=I18nService.js.map
